import React from 'react';

const GooglePlay: React.FC<React.SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="104"
      height="25"
      fill="none"
      viewBox="0 0 104 25"
      {...props}
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="0.107"
        d="M33.385 3.868c0 .727-.223 1.31-.662 1.744-.505.514-1.162.773-1.968.773-.77 0-1.428-.263-1.967-.782-.54-.527-.81-1.173-.81-1.947 0-.773.27-1.42.81-1.942.54-.523 1.197-.787 1.967-.787.383 0 .749.077 1.098.221.347.145.63.34.836.582l-.466.46c-.358-.413-.845-.616-1.468-.616-.562 0-1.049.191-1.462.577-.41.388-.614.89-.614 1.505 0 .616.205 1.122.614 1.51.413.381.9.577 1.462.577.596 0 1.098-.196 1.493-.582.261-.256.41-.608.449-1.059h-1.942v-.629h2.59c.031.136.04.268.04.395zM37.494 1.688h-2.433v1.654h2.193v.63h-2.193v1.653h2.433v.641h-3.122V1.048h3.122v.64zM40.395 6.266h-.689V1.69h-1.492v-.641h3.675v.64h-1.494v4.578zM44.547 6.266V1.048h.688v5.218h-.688zM48.282 6.266H47.6V1.69h-1.498v-.641h3.68v.64h-1.498v4.578zM56.737 5.594c-.527.528-1.18.791-1.959.791-.783 0-1.436-.263-1.963-.79-.526-.528-.788-1.174-.788-1.939 0-.765.261-1.411.788-1.938.527-.527 1.18-.79 1.963-.79.775 0 1.428.263 1.955.795.53.53.792 1.173.792 1.933 0 .765-.261 1.411-.788 1.938zm-3.413-.437c.397.39.88.586 1.454.586.57 0 1.058-.196 1.45-.586.396-.39.596-.893.596-1.5 0-.609-.2-1.11-.596-1.501a1.981 1.981 0 00-1.45-.587c-.575 0-1.057.196-1.454.587-.396.39-.596.892-.596 1.5s.2 1.11.596 1.5zM58.492 6.266V1.048h.835l2.6 4.058h.03l-.03-1.003V1.048h.687v5.218h-.718l-2.721-4.259h-.03l.03 1.008v3.251h-.683z"
      />
      <path
        fill="currentColor"
        d="M51.856 13.887c-2.095 0-3.805 1.556-3.805 3.703 0 2.13 1.71 3.702 3.805 3.702 2.098 0 3.809-1.572 3.809-3.702 0-2.146-1.71-3.703-3.81-3.703zm0 5.947c-1.15 0-2.138-.926-2.138-2.244 0-1.335.989-2.244 2.138-2.244s2.142.91 2.142 2.244c0 1.318-.993 2.244-2.142 2.244zm-8.302-5.947c-2.099 0-3.805 1.556-3.805 3.703 0 2.13 1.706 3.702 3.805 3.702 2.097 0 3.805-1.572 3.805-3.702 0-2.146-1.708-3.703-3.805-3.703zm0 5.947c-1.15 0-2.142-.926-2.142-2.244 0-1.335.992-2.244 2.142-2.244 1.149 0 2.137.91 2.137 2.244 0 1.318-.988 2.244-2.137 2.244zm-9.879-4.812v1.574h3.849c-.113.879-.414 1.525-.875 1.976-.562.544-1.437 1.148-2.974 1.148-2.368 0-4.222-1.866-4.222-4.179 0-2.312 1.854-4.178 4.222-4.178 1.28 0 2.212.489 2.9 1.122l1.136-1.109c-.962-.896-2.242-1.585-4.036-1.585-3.247 0-5.977 2.58-5.977 5.75 0 3.171 2.73 5.751 5.977 5.751 1.756 0 3.074-.561 4.11-1.615 1.063-1.037 1.394-2.495 1.394-3.672 0-.366-.032-.702-.087-.983h-5.417zm40.395 1.22c-.313-.828-1.28-2.355-3.247-2.355-1.95 0-3.574 1.501-3.574 3.703 0 2.074 1.607 3.702 3.761 3.702a3.78 3.78 0 003.16-1.64l-1.292-.842c-.431.616-1.019 1.024-1.868 1.024-.844 0-1.449-.378-1.837-1.122l5.072-2.049-.175-.42zm-5.17 1.233a2.053 2.053 0 011.98-2.159c.662 0 1.223.323 1.41.786l-3.39 1.373zm-4.123 3.592h1.667V10.186h-1.667v10.88zm-2.73-6.355h-.056c-.375-.433-1.09-.825-1.994-.825-1.9 0-3.636 1.628-3.636 3.715 0 2.075 1.737 3.69 3.636 3.69.905 0 1.62-.395 1.994-.841h.055v.53c0 1.417-.774 2.177-2.024 2.177-1.018 0-1.65-.718-1.91-1.322l-1.45.59c.417.982 1.524 2.19 3.36 2.19 1.955 0 3.605-1.123 3.605-3.855v-6.648h-1.58v.6zm-1.908 5.122c-1.149 0-2.11-.939-2.11-2.232 0-1.304.961-2.256 2.11-2.256 1.133 0 2.025.952 2.025 2.256 0 1.293-.892 2.232-2.025 2.232zm21.737-9.648h-3.988v10.88h1.663v-4.122h2.325c1.847 0 3.658-1.305 3.658-3.38 0-2.074-1.816-3.378-3.658-3.378zm.043 5.244h-2.368V11.7h2.368a1.91 1.91 0 011.95 1.864c0 .842-.708 1.866-1.95 1.866zm10.28-1.563c-1.202 0-2.451.518-2.965 1.666l1.475.604c.318-.604.902-.8 1.52-.8.862 0 1.737.506 1.75 1.4v.113c-.3-.17-.945-.42-1.737-.42-1.59 0-3.209.854-3.209 2.448 0 1.458 1.302 2.397 2.765 2.397 1.12 0 1.737-.493 2.124-1.067h.057v.841h1.606v-4.174c0-1.929-1.475-3.008-3.387-3.008zm-.201 5.963c-.544 0-1.302-.264-1.302-.922 0-.842.945-1.165 1.763-1.165.732 0 1.076.157 1.52.365-.13 1.008-1.018 1.722-1.981 1.722zm9.438-5.725l-1.911 4.717h-.057l-1.976-4.717H95.7l2.969 6.592-1.694 3.668h1.737l4.575-10.26h-1.85zm-14.988 6.962h1.667V10.186h-1.667v10.88z"
      />
      <path
        fill="url(#paint0_linear_681:3160)"
        d="M.413 1.515C.152 1.783 0 2.199 0 2.739v19.25c0 .54.152.957.413 1.225l.065.059L11.527 12.49v-.255L.478 1.452l-.065.063z"
      />
      <path
        fill="url(#paint1_linear_681:3160)"
        d="M15.206 16.084l-3.68-3.596v-.255l3.684-3.596.082.047 4.362 2.423c1.245.688 1.245 1.82 0 2.511l-4.362 2.42-.086.046z"
      />
      <path
        fill="url(#paint2_linear_681:3160)"
        d="M15.292 16.039l-3.765-3.677L.413 23.214c.414.424 1.088.475 1.855.05l13.024-7.225z"
      />
      <path
        fill="url(#paint3_linear_681:3160)"
        d="M15.292 8.684L2.267 1.458C1.5 1.038.826 1.09.412 1.514L11.526 12.36l3.766-3.677z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_681:3160"
          x1="10.546"
          x2="-4.059"
          y1="22.19"
          y2="7.232"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.007" stopColor="#00A1FF" />
          <stop offset="0.26" stopColor="#00BEFF" />
          <stop offset="0.512" stopColor="#00D2FF" />
          <stop offset="0.76" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_681:3160"
          x1="21.276"
          x2="-0.298"
          y1="12.359"
          y2="12.359"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.409" stopColor="#FFBD00" />
          <stop offset="0.775" stopColor="orange" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_681:3160"
          x1="13.245"
          x2="-6.56"
          y1="10.363"
          y2="-9.922"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_681:3160"
          x1="-2.385"
          x2="6.459"
          y1="29.617"
          y2="20.559"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.069" stopColor="#2DA771" />
          <stop offset="0.476" stopColor="#15CF74" />
          <stop offset="0.801" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default React.memo(GooglePlay);
